import { render, staticRenderFns } from "./SelectedTemplateAssign.vue?vue&type=template&id=0c3bcb64&"
import script from "./SelectedTemplateAssign.vue?vue&type=script&lang=ts&"
export * from "./SelectedTemplateAssign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports